import { useEffect, useRef, useState } from "react";
import axios from "src/lib/axios";
import { getPreviewUrl } from "src/utils/getBlobUrl";

export function useImagePreview(rawUrl, options = {}) {
  const { axiosInstance = axios, fallbackToRawOnError = false } = options;
  const [previewUrl, setPreviewUrl] = useState(null);
  const blobRef = useRef(null);

  useEffect(() => {
    if (!rawUrl || typeof rawUrl !== "string") {
      setPreviewUrl(null);
      return;
    }
    const isRemote =
      rawUrl.startsWith("http://") || rawUrl.startsWith("https://");
    if (!isRemote) {
      setPreviewUrl(null);
      return;
    }

    const imageUrl = getPreviewUrl(rawUrl);
    const abortController = new AbortController();
    let cancelled = false;

    axiosInstance
      .get(imageUrl, {
        responseType: "blob",
        signal: abortController.signal,
      })
      .then((res) => {
        if (cancelled || res.status !== 200) return;
        if (res.data?.type && !res.data.type.startsWith("image/")) return;
        if (blobRef.current) URL.revokeObjectURL(blobRef.current);
        const blobUrl = URL.createObjectURL(res.data);
        blobRef.current = blobUrl;
        if (!cancelled) setPreviewUrl(blobUrl);
        else URL.revokeObjectURL(blobUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setPreviewUrl(fallbackToRawOnError ? rawUrl : null);
        }
      });

    return () => {
      cancelled = true;
      abortController.abort();
      if (blobRef.current) {
        URL.revokeObjectURL(blobRef.current);
        blobRef.current = null;
      }
      setPreviewUrl(null);    };
  }, [rawUrl, axiosInstance, fallbackToRawOnError]);

  return previewUrl;
}
